export class MemberTypeModel {
  public mbt_key: string = undefined;
  public mbt_asn_code: string = undefined;
  public mbt_code: string = undefined;
  public mbt_wizard_level_ext: ('Professional' | 'Associate' | 'Student' | 'Graduate')[] = undefined;
  public mbt_wizard_title_ext: string = undefined;
  public mbt_wizard_price_text_ext: string = undefined;
  public mbt_wizard_description_ext: string = undefined;
  public mbt_wizard_order_ext: number = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
